import { Widget } from '@widgets/widget';
import { CreditsListWidgetComponent, GroupsListWidgetComponent } from '@widgets/widgets';
import { MyPlanComponent } from '@widgets/components/my-plan/my-plan.component';
import { SubscriptionActivationComponent } from '@widgets/components/subscription-activation/subscription-activation.component';
import { StudentCourseComponent } from '@widgets/components/student-course/student-course.component';
import { TrainingHourComponent } from '@widgets/components/training-hour/training-hour.component';
import { StudentCommentComponent } from '@widgets/components/student-comment/student-comment.component';
import { ScheduledClassComponent } from '@widgets/components/scheduled-class/scheduled-class.component';
import { MetricComponent } from '@widgets/components/metric/metric.component';
import { NpsComponent } from '@widgets/components/nps/nps.component';
import { AutoevaluationComponent } from '@widgets/components/autoevaluation/autoevaluation.component';
import { AutoevaluationCoursesComponent } from '@widgets/components/autoevaluationCourses/autoevaluationCourses.component';
import { ApplicabilityComponent } from '@widgets/components/applicability/applicability.component';
import { Client, Profile } from 'core/models';
import { Metric } from '@widgets/models/Metric';
import { AutoevaluationsSummary } from '@widgets/models/AutoevaluationsSummary';
import { CourseAutoevaluationsSummary } from '@widgets/models/CourseAutoevaluationsSummary';
import { TrainingHours } from '@widgets/models/TrainingHours';
import { StudentCourse } from '@widgets/models/StudentCourse';
import { StudentComment } from '@widgets/models/StudentComment';
import { ScheduledClass } from '@widgets/models/ScheduledClass';
import { MetricApplicability } from '@widgets/models/MetricApplicability';
import moment from 'moment';

export const GroupListComponent = (user, role, id, tipeWidget) => {
  const inAMonth = moment().add(1, 'month').toISOString();
  const now = new Date().toISOString();
  // supportSpecialist/csm
  return new Widget(GroupsListWidgetComponent, {
    id: `widget-${id}`,
    name: `widget-${id}`,
    title: tipeWidget === 'start' ? 'dashboard.widgets.startingGroups' : 'dashboard.widgets.endingGroups',
    class: 'col s6',
    columns: ['name', tipeWidget === 'start' ? 'startDate' : 'endDate'],
    filter:
      `agentIds eq '${user.id}' and ` +
      (tipeWidget === 'start'
        ? `startDate ge '${now}'`
        : `startDate lt '${now}' and endDate lt '${inAMonth}' and endDate ge '${now}'`),
    sort: tipeWidget === 'start' ? 'startDate' : 'endDate',
    user,
    role
  });
};

export const CreditsListComponent = (user, role, id, tipeWidget) => {
  const inAMonth = moment().add(1, 'month').toISOString();
  const now = new Date().toISOString();
  // supportSpecialist/csm/csAdmin
  return new Widget(CreditsListWidgetComponent, {
    id: `widget-${id}`,
    name: `widget-${id}`,
    title: tipeWidget === 'start' ? 'dashboard.widgets.startingGroups' : 'dashboard.widgets.endingGroups',
    class: 'col s6',
    columns: ['name', tipeWidget === 'start' ? 'startDate' : 'endDate'],
    filter:
      'availableCredits gt 0 and ' +
      `client/agentIds eq '${user.id}' and ` +
      (tipeWidget === 'start'
        ? `startDate ge '${now}'`
        : `startDate lt '${now}' and endDate lt '${inAMonth}' and endDate ge '${now}'`),
    sort: tipeWidget === 'start' ? 'startDate' : 'endDate',
    user,
    role
  });
};

export const MyPlanWidget = (
  user: Profile,
  role: any,
  id: number,
  myPlan: any,
  type: string,
  managedAccounts?: Client[]
) => {
  return new Widget(MyPlanComponent, {
    id: `widget-${id}`,
    name: `widget-${id}`,
    class: 'gl-dashboard__item',
    user,
    role,
    myPlan,
    managedAccounts,
    type
  });
};
export const SubscriptionActivationWidget = (
  user: Profile,
  role: any,
  id: number,
  activation: any,
  type: string,
  managedAccounts?: Client[]
) => {
  return new Widget(SubscriptionActivationComponent, {
    id: `widget-${id}`,
    name: `widget-${id}`,
    class: 'gl-dashboard__item',
    user,
    role,
    activation,
    managedAccounts,
    type
  });
};

export const TrainingHourWidget = (
  user: Profile,
  role: any,
  id: number,
  trainingHours: TrainingHours,
  clientIds: string[],
  managedAccounts?: Client[]
) => {
  return new Widget(TrainingHourComponent, {
    id: `widget-${id}`,
    name: `widget-${id}`,
    class: 'gl-dashboard__item',
    user,
    role,
    trainingHours,
    clientIds,
    managedAccounts
  });
};

export const MetricWidget = (
  user: Profile,
  role: any,
  id: number,
  metric: Metric,
  clientIds: string[],
  managedAccounts?: Client[]
) => {
  return new Widget(MetricComponent, {
    id: `widget-${id}`,
    name: `widget-${id}`,
    class: 'gl-dashboard__item metrics',
    user,
    role,
    metric,
    clientIds,
    managedAccounts
  });
};

export const NpsWidget = (
  user: Profile,
  role: any,
  id: number,
  metric: Metric,
  clientIds: string[],
  managedAccounts?: Client[]
) => {
  return new Widget(NpsComponent, {
    id: `widget-${id}`,
    name: `widget-${id}`,
    class: 'gl-dashboard__item nps',
    user,
    role,
    metric,
    clientIds,
    managedAccounts
  });
};

export const AutoevaluationWidget = (user: Profile, role: any, id: number, autoevaluations: AutoevaluationsSummary) => {
  return new Widget(AutoevaluationComponent, {
    id: `widget-${id}`,
    name: `widget-${id}`,
    class: 'gl-dashboard__item',
    user,
    role,
    autoevaluations
  });
};

export const AutoevaluationCoursesWidget = (
  user: Profile,
  role: any,
  id: number,
  coursesAutoevaluations: CourseAutoevaluationsSummary,
  clientIds: string[],
  managedAccounts?: Client[]
) => {
  return new Widget(AutoevaluationCoursesComponent, {
    id: `widget-${id}`,
    name: `widget-${id}`,
    class: 'gl-dashboard__item autoevaluation',
    user,
    role,
    coursesAutoevaluations,
    clientIds,
    managedAccounts
  });
};

export const CourseStudentWidget = (user: Profile, role: any, id: number, studentCourses: StudentCourse[]) => {
  return new Widget(StudentCourseComponent, {
    id: `widget-${id}`,
    name: `widget-${id}`,
    class: 'gl-dashboard__item students',
    user,
    role,
    studentCourses
  });
};

export const StudentCommentWidget = (user: Profile, role: any, id: number, studentComments?: StudentComment[]) => {
  return new Widget(StudentCommentComponent, {
    id: `widget-${id}`,
    name: `widget-${id}`,
    class: 'gl-dashboard__item',
    user,
    role,
    studentComments
  });
};

export const ScheduledClassWidget = (
  user: Profile,
  role: any,
  id: number,
  scheduledClass: ScheduledClass,
  client?: Client
) => {
  return new Widget(ScheduledClassComponent, {
    id: `widget-${id}`,
    name: `widget-${id}`,
    class: 'gl-dashboard__item hours',
    user,
    role,
    scheduledClass,
    client
  });
};

export const ApplicabilityComponentWidget = (
  user: Profile,
  role: any,
  id: number,
  metricApplicability: MetricApplicability,
  managedAccounts?: Client[]
) => {
  return new Widget(ApplicabilityComponent, {
    id: `widget-${id}`,
    name: `widget-${id}`,
    class: 'gl-dashboard__item autoevaluation',
    user,
    role,
    metricApplicability,
    managedAccounts
  });
};
